import { isNumber } from "lodash"

percentFilter.$inject = ['$filter']

function percentFilter($filter) {
  return function (number, fractionSize) {
    var numberFilter = $filter('number')
    fractionSize = isNumber(fractionSize) ? fractionSize : 2

    var viewValue = numberFilter(number, fractionSize)

    return viewValue ? (`${viewValue}%`) : ''
  }
}

export default percentFilter
